import { render } from "./HowToOrder.vue?vue&type=template&id=b7271b4e"
import script from "./HowToOrder.vue?vue&type=script&lang=js"
export * from "./HowToOrder.vue?vue&type=script&lang=js"

import "./HowToOrder.vue?vue&type=style&index=0&id=b7271b4e&lang=css"

import exportComponent from "D:\\perso\\miam\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__